import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { cashCodAccessRoles, cashCodWriteRoles } from './access';

const accessRoles = { roles: [...cashCodAccessRoles] } as const;
const writeRoles = { roles: [...cashCodWriteRoles] } as const;

export const cashCodRoutes: RouteObject[] = [
  {
    path: 'cash-cod',
    async lazy() {
      const { CashCodEntryPage } = await import('./pages/CashCodEntryPage');
      return { Component: CashCodEntryPage };
    },
    handle: defineHandle({
      ...accessRoles,
      breadcrumb: 'common:nav.cashCod',
      title: 'common:nav.cashCod',
    }),
  },
  {
    path: 'cash-cod/:storeId',
    async lazy() {
      const { CodCashOverviewPage } = await import('./pages/CodCashOverviewPage');
      return { Component: CodCashOverviewPage };
    },
    handle: defineHandle({
      ...accessRoles,
      breadcrumb: 'cashCod:overview.title',
      title: 'cashCod:overview.title',
    }),
  },
  {
    path: 'cash-cod/:storeId/receive',
    async lazy() {
      const { CodCashReceivePage } = await import('./pages/CodCashReceivePage');
      return { Component: CodCashReceivePage };
    },
    handle: defineHandle({
      ...writeRoles,
      breadcrumb: 'cashCod:receive.title',
      title: 'cashCod:receive.title',
    }),
  },
  {
    path: 'cash-cod/:storeId/day-close',
    async lazy() {
      const { CodCashDayClosePage } = await import('./pages/CodCashDayClosePage');
      return { Component: CodCashDayClosePage };
    },
    handle: defineHandle({
      ...accessRoles,
      breadcrumb: 'cashCod:dayClose.title',
      title: 'cashCod:dayClose.title',
    }),
  },
  {
    path: 'cash-cod/:storeId/transfer',
    async lazy() {
      const { CodCashTransferPage } = await import('./pages/CodCashTransferPage');
      return { Component: CodCashTransferPage };
    },
    handle: defineHandle({
      ...writeRoles,
      breadcrumb: 'cashCod:transfer.title',
      title: 'cashCod:transfer.title',
    }),
  },
];
